const VIEWPORT_PADDING = 16

/**
 * Сдвигает тултип «У квеста есть особенность» внутрь viewport при наведении на иконку.
 */
export function initQuestAttentionTooltips(): void {
  const wrappers = document.querySelectorAll<HTMLElement>(
    '.quest-attention-tooltip'
  )

  wrappers.forEach((wrapper) => {
    const tooltip = wrapper.querySelector<HTMLElement>(
      '.quest-attention-tooltip__tooltip'
    )
    if (!tooltip) return

    wrapper.addEventListener('pointerenter', () => updatePosition(tooltip))
    wrapper.addEventListener('pointerleave', () => resetPosition(tooltip))
  })
}

function updatePosition(tooltip: HTMLElement): void {
  window.requestAnimationFrame(() => {
    const tooltipRect = tooltip.getBoundingClientRect()
    let shiftX = 0

    if (tooltipRect.left < VIEWPORT_PADDING) {
      shiftX = VIEWPORT_PADDING - tooltipRect.left
    } else if (tooltipRect.right > window.innerWidth - VIEWPORT_PADDING) {
      shiftX = window.innerWidth - VIEWPORT_PADDING - tooltipRect.right
    }

    tooltip.style.setProperty('--tooltip-shift-x', `${shiftX}px`)
  })
}

function resetPosition(tooltip: HTMLElement): void {
  tooltip.style.removeProperty('--tooltip-shift-x')
}
